import CommonRadioMulSelect from '../CommonRadioMulSelect';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const CustomerTag = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { selectOptions, radioName, selectName, noStyle } = props;
  return (
    <CommonRadioMulSelect
      selectOptions={selectOptions}
      radioName={radioName}
      selectName={selectName}
      noStyle={noStyle}
      selectPlaceholder={getI18n(
        'general.advancedFilters.customerTag.placeholder',
      )}
    />
  );
};
export default CustomerTag;
